import { useChainId, useChains } from "wagmi";

interface BlockExplorerUrls {
    getTransactionUrl: (transactionHash: `0x${string}`) => string | undefined;
    baseUrl: string | undefined;
}

export function useBlockExplorer(): BlockExplorerUrls {
    const chainId = useChainId();
    const chains = useChains();

    const currentChain = chains.find((chain) => chain.id === chainId);
    const baseUrl = currentChain?.blockExplorers?.default.url;

    return {
        getTransactionUrl: (transactionHash) => (baseUrl ? `${baseUrl}/tx/${transactionHash}` : undefined),
        baseUrl,
    };
}
